'use client';
import { useOptimistic, useTransition } from 'react';
import { IoClose } from 'react-icons/io5';

import cn from '@/lib/clsxm';

import Button from '@/components/@base/button';
import Props from '@/components/app/archive/components/filter/@shared/clear-filters-button/type';
import { useFilterParams } from '@/components/app/archive/helpers/hooks';

import ICON_SIZE from '@/constant/icon-size-color';
import { pageLevelLocalization } from '@/constant/localization';

const { archive: archiveLocalization } = pageLevelLocalization;

export default function ClearFiltersButton({ className, initialFilters }: Props) {
  const { clearParams } = useFilterParams({
    searchParams: initialFilters,
  });
  const [showButton, setShowButton] = useOptimistic(Object.keys(initialFilters).length > 0);
  let [isPending, startTransition] = useTransition();

  const handleClick = () => {
    startTransition(() => {
      setShowButton(false);
      clearParams();
    });
  };

  return (
    <Button
      className={cn(
        'mb-4 rounded-none border-b-2 border-dashed bg-transparent p-0 opacity-0 transition-opacity duration-300 ease-in-out',
        className,
        showButton && 'opacity-100',
      )}
      onClick={handleClick}
      data-pending={isPending ? '' : undefined}
    >
      <IoClose size={ICON_SIZE.md} />
      {archiveLocalization.filter.removeFilters}
    </Button>
  );
}
